module.exports = __webpack_public_path__ + "static/the-how-of-happiness-3fad982332f051bfc28c3a7578fd7564.jpg";